import React, { useEffect, useState } from 'react'
import CarRegistrationNumberPlate from '../../../../components/Elements/CarRegistrationNumberPlate'
import { FaCalendarAlt, FaChevronLeft } from 'react-icons/fa'
import { Card, Col, Pagination, Row, Tooltip } from 'antd'
import { Link, useNavigate } from 'react-router-dom'
import carPlaceholder from '../../../../assets/images/car.png'
import useBookingApi from '../../../../config/hooks/api/booking/useBookingApi'
import { useDispatch, useSelector } from 'react-redux'
import { setAppLoading, setMessage } from '../../../../store/common/generalSlice'
import { getFormattedDateTime, getServicesList } from '../../../../config/utils'
import { setSelectedRequestDetails } from '../../../../store/common/bookingSlice/requestSlice'
import { getMatchingIds } from '../../../../config/utils/GetMatchingIds'
import BookingForm from '../../../../components/BookingForm'
import { filtersDataFormatter } from '../../../../config/utils/FiltersDataFormatter'
import { filtersSelectedDataFormatter } from '../../../../config/utils/FiltersSelectedDataFormatter'
import { extractValues } from '../../../../config/utils/ExtractValues'
import Modal from '../../../../components/Modal'


const MyRequestsForProposal = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { getMyRequestsForProposal, updateBooking } = useBookingApi()
    const { services } = useSelector(state => state?.services);
    console.log(services)

    const [offset, setOffset] = useState(0)
    const [pageSize, setPageSize] = useState(5)
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0)

    const [requests, setRequests] = useState([])
    const [formattedData, setFormattedData] = useState(null)
    const [bookingToEdit, setBookingToEdit] = useState(null)
    const [showBookingForm, setShowBookingForm] = useState(false)
    const [reset, setReset] = useState(false);
    const [initialData, setInitialData] = useState([])

    useEffect(() => {
        setInitialData(filtersDataFormatter(services))
    }, [services])

    const getRequests = async () => {

        try {
            dispatch(setAppLoading(true))

            const response = await getMyRequestsForProposal(reset ? 5 : pageSize, reset ? 0 : offset)
            if (response) {
                setRequests(response?.data?.quotedBookings?.rows)

                setTotalItems(response?.data?.quotedBookings?.count)
                setOffset(offset + pageSize)

                dispatch(setAppLoading(false))
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const onShowSizeChange = (current, pageSize) => {
        setPageSize(pageSize)
    };

    const onPageChange = (page) => {
        setCurrentPage(page);
        setOffset((page - 1) * pageSize)
    };

    const handleRequestDetails = (requestData) => {
        if (!requestData) return null

        dispatch(setSelectedRequestDetails(requestData))
        navigate(`/request/${requestData?.id}`)
    }

    const bookingFormDataOrStatusHandler = async (data) => {
        const { selectedCategories } = bookingToEdit;
        try {
            dispatch(setAppLoading(true))
            const temp = structuredClone(data);
            let finalSelectedValues;
            const payload = {
                ...temp?.fetchedVehicleData,
                ...temp?.location,
                serviceProviderId: bookingToEdit?.serviceProviderId,
                quote: false,
                ...temp
            }

            if (selectedCategories) {
                // handling a specific case here to get an array of ids of first Layer
                // second Layer and third Layer based on the third layer values only.
                finalSelectedValues = getMatchingIds(services, data?.services);
            }

            payload.vehicleRegistrationNo = data?.fetchedVehicleData?.vehicleRegistrationNumber
            // payload.services = [].concat(...Object.values(temp?.services))
            payload.services = finalSelectedValues //dev env
            // payload.services = [77,80,83] //QA env
            payload.year = payload.year + ''

            const validKeys = [
                "services",
                "make",
                "model",
                "engineSize",
                "fuelType",
                "year",
                "vehicleRegistrationNo",
                "longitude",
                "latitude",
                "address",
                "postalCode",
                "details"
            ]

            const finalPayload = {}

            for (let i = 0; i < validKeys.length; i++) {
                finalPayload[validKeys[i]] = payload[validKeys[i]] ? payload[validKeys[i]] : ''
            }
            console.log(finalPayload)
            const response = await updateBooking(finalPayload, bookingToEdit?.id)
            if (response) {
                dispatch(setAppLoading(false))

                dispatch(setMessage(response?.data?.message))
                setOffset(0)
                setPageSize(5)
                setReset(true)
                setShowBookingForm(false)
            }
        } catch (error) {
            console.log(error)
            dispatch(setAppLoading(false))
        }
    }

    const handleEditBooking = (selectedQuoteBooking) => {
        setShowBookingForm(true)
        const { id, address, latitude, longitude, postalCode, details, services, selectedCategories } = selectedQuoteBooking

        const initialData = filtersDataFormatter(selectedCategories);
        let selectedData;
        let selectedValues;
        if (initialData) {
            selectedData = filtersSelectedDataFormatter(initialData);
            // extract values func is used to get only the array of selected values from our 
            // modal's selected values object format.
            selectedValues = extractValues(selectedData);
        }
        setFormattedData({
            initialData,
            selectedData
        });
        setBookingToEdit({
            id,
            carRegNo: selectedQuoteBooking?.vehicleRegistrationNo,
            location: { address, latitude, longitude, postalCode },
            // passing selected Values which is only an array of third layer values to get
            // the correct count initially and on deselect or select of any values from modal.
            services: selectedValues,
            details,
            selectedCategories
        })
    }

    useEffect(() => {
        getRequests()
    }, [currentPage, pageSize])

    useEffect(() => {
        if (reset) {
            getRequests()
            setReset(false)
        }
    }, [reset])

    return (
        <Row className='mb-4'>
            <Col md={24} sm={24} xs={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                <div className='flex justify-between items-center'>
                    <h5 className='heading-5 text-slate-600 font-semibold'>My Quotes</h5>
                    <Link to='/' className='cursor-pointer flex items-center'>
                        <FaChevronLeft className='text-primary bg-white p-2 rounded-full text-3xl' />
                        <small className='ml-2 font-medium'>Back</small>
                    </Link>
                </div>
            </Col>
            <Col span={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                {
                    requests &&
                        requests.length ?
                        requests.map(request => {
                            let servicesLength = request?.services?.length || 0;
                            return (
                                <Card
                                    key={'request' + request?.id}
                                    bordered={false}
                                    className='mb-4 rounded-md'

                                >
                                    <div className='flex sm:flex-row flex-col justify-between'>
                                        <div
                                            className='flex sm:flex-row flex-col sm:w-4/6 w-full sm:mb-0 mb-2 cursor-pointer'
                                            onClick={() => handleRequestDetails(request)}
                                        >
                                            <div className='flex sm:flex-row flex-col justify-center items-center mb-4'>
                                                <img src={carPlaceholder} alt='car' className='img-fluid h-[80px]' />
                                            </div>
                                            <div className='sm:ml-2'>
                                                <div className='mb-4 ml-1'>
                                                    <div className='flex justify-center sm:justify-start'>
                                                        <h3 className='heading-3 font-bold mb-1'>
                                                            {
                                                                request?.selectedCategories &&
                                                                    request?.selectedCategories?.length > 0 ?
                                                                    request?.selectedCategories[0].name : '-'
                                                            }
                                                        </h3>
                                                    </div>
                                                    {/* <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            request?.services &&
                                                                request?.selectedCategories?.length > 0 ? (
                                                                <React.Fragment>
                                                                    {
                                                                        request?.selectedCategories[0].subServices?.length > 0 ?
                                                                            <span className='flex gap-1 items-center'>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                    {request?.selectedCategories[0].name + ','}
                                                                                </p>
                                                                                <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                    {request?.selectedCategories[0].subServices[0]?.name + ' ...'}                                                                            </p>
                                                                            </span>
                                                                            :
                                                                            <p>-</p>

                                                                    }
                                                                    {request?.selectedCategories?.length > 0 &&
                                                                        request?.selectedCategories[0]?.subServices?.length > 0 &&
                                                                        request?.selectedCategories[0]?.subServices[0]?.subServices?.length > 0
                                                                        ? (
                                                                            <Tooltip title={getServicesList(request?.selectedCategories[0]?.subServices[0]?.subServices, true)}>
                                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        ) : ''}
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                        }
                                                    </div> */}

                                                    <div className='flex justify-center sm:justify-start'>
                                                        {
                                                            request?.services &&
                                                                servicesLength > 0 ? (
                                                                <React.Fragment>
                                                                    {
                                                                        request?.services?.slice(0, 3)?.map((service) => {
                                                                            return (
                                                                                <span className='flex gap-1 items-center' key={service?.id}>
                                                                                    <p className='text-gray-500 font-semibold text-xs mb-3'>
                                                                                        {service?.name + ','}
                                                                                    </p>
                                                                                </span>
                                                                            )
                                                                        })
                                                                    }
                                                                    {servicesLength > 4 && <span>...</span>}
                                                                    {servicesLength > 4 &&
                                                                        (
                                                                            <Tooltip title={getServicesList(request?.services, false)}>
                                                                                <p className='text-xs ml-2 cursor-pointer'>show all</p>
                                                                            </Tooltip>
                                                                        )
                                                                    }
                                                                </React.Fragment>
                                                            ) : (
                                                                <small className='text-xs'>Services not available</small>
                                                            )
                                                        }
                                                    </div>

                                                    <div className='flex justify-center sm:justify-start items-center mr-4'>
                                                        <div className='md'>
                                                            <CarRegistrationNumberPlate regNumber={request?.vehicleRegistrationNo} />
                                                        </div>
                                                        <div className='flex ml-4 justify-center items-center'>
                                                            <FaCalendarAlt className='bg-[#fa3434] text-white rounded-full p-[5px] text-2xl' />
                                                            <small className='text-xs font-md ml-2'>
                                                                {getFormattedDateTime(request?.createdAt, 'DD-MM-YYYY')}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='flex flex-col items-end sm:w-2/6 w-full'>
                                            <div className='flex flex-col items-center sm:w-fit w-full'>
                                                <h1 className='heading-1 font-bold mb-0'>{request?.quotesReceived}</h1>
                                                <p className='text-center sm:text-xs text-sm font-semibold mb-2'>Quotes Received</p>
                                            </div>
                                            <div className='mb-2 sm:w-fit w-full flex sm:flex-row flex-col'>
                                                {
                                                    !request?.quotesReceived ? (
                                                        <div
                                                            onClick={() => handleEditBooking(request)}
                                                            className='
                                                        sm:w-fit 
                                                        w-full 
                                                        sm:py-3 
                                                        py-4 
                                                        p-3 
                                                        sm:text-xs 
                                                        text-lg
                                                        rounded-lg 
                                                        bg-black 
                                                        text-white
                                                        text-center
                                                        cursor-pointer
                                                        sm:mr-2
                                                        sm:mb-0
                                                        mb-2
                                                        '
                                                        >
                                                            Edit Job
                                                        </div>
                                                    )
                                                        : null
                                                }
                                                <div
                                                    onClick={() => navigate(`/request/${request?.id}/quotes`)}
                                                    className='
                                                    sm:w-fit 
                                                    w-full 
                                                    sm:py-3 
                                                    py-4 
                                                    p-3 
                                                    sm:text-xs 
                                                    text-lg
                                                    rounded-lg 
                                                    bg-[#02B563] 
                                                    text-white
                                                    text-center
                                                    cursor-pointer
                                                '
                                                >
                                                    View Quotes
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            )
                        })
                        : 'No Data Available'
                }

                <Modal.Basic
                    open={showBookingForm}
                    onCancel={() => setShowBookingForm(false)}
                    width={300}
                    rootClassName={'edit-quote-booking'}
                >
                    <div className='p-4 bg-black rounded-lg w-[300px]'>
                        <BookingForm
                            spServicesData={initialData}
                            selectedFiltersValue={formattedData?.selectedData}
                            editData={bookingToEdit}
                            bookingFormDataOrStatusHandler={bookingFormDataOrStatusHandler}
                            isServicesFilled={true}
                        />
                    </div>
                </Modal.Basic>
            </Col>
            <Col span={24} className='md:px-20 sm:px-20 md:pt-6 sm:pt-6 px-2 pt-6'>
                <div className='px-2 py-4 bg-white rounded-md'>
                    <Pagination
                        defaultPageSize={5}
                        showSizeChanger
                        onShowSizeChange={onShowSizeChange}
                        current={currentPage}
                        total={totalItems}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 20, 50]}
                        onChange={onPageChange}
                    />
                </div>
            </Col>
        </Row>
    )
}

export default MyRequestsForProposal